"poor man's use server";
import { createRpcFetcher as _createRpcFetcher } from "server-actions-for-next-pages/dist/browser";
export const createStripeCheckoutSession = /*#__PURE__*/ _createRpcFetcher("/api/stripe/stripe-functions", "createStripeCheckoutSession");
export const createStripePortal = /*#__PURE__*/ _createRpcFetcher("/api/stripe/stripe-functions", "createStripePortal");
